import styled from 'styled-components';

export const AssocCustomersPanel = styled.div`
  background: #fff;
  border-radius: 5px;
  padding: 14px 8px;
  margin-bottom: 24px;
  box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.25);

  .ant-collapse-header {
    display: flex;
    align-items: center;
  }

  .ant-table-content {
    overflow-x: auto;
  }
  .ant-table-thead {
    tr {
      .ant-table-cell {
        padding: 0.5rem;
        border-top: 1px solid #d5dee7;
        border-bottom: 1px solid #d5dee7;
        border-left: 1px solid #d5dee7;
        background: #eef4fa;
        vertical-align: top;
        font-size: 10px;
        font-weight: 500;
        font-style: normal;
        line-height: 12px;
        color: #556069;
        &:last-of-type {
          border-right: 1px solid #d5dee7;
        }
      }
    }
  }
  .ant-table-tbody {
    tr {
      .ant-table-cell {
        padding: 0.75rem 0.5rem;
        font-style: normal;
        font-weight: normal;
        font-size: 11px;
        line-height: 12px;
        color: #556069;
        strong {
          font-weight: 500;
        }
      }
      &:nth-child(even) {
        background: #f7f8f9;
      }
      &:last-of-type {
        td {
          border-bottom: 1px solid #d5dee7;
        }
      }
    }
  }
  .ant-pagination {
    .ant-pagination-item {
      color: #31394d;
      border-radius: 4px;
    }
    .ant-pagination-item-active {
      color: #21b4bd;
      border-color: #21b4bd;
    }
    .ant-pagination-total-text {
      color: #b8bec5;
      line-height: 2rem;
    }
    .ant-pagination-item-link {
      border-radius: 4px;
    }
    .anticon {
      vertical-align: text-top;
    }
  }
`;

export const AssocCustomerHeader = styled.div`
  padding: 4px 0;
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
`;
